import axios from "axios";

export const updateOptIn = (
    InspectionId: string,
    CustomerOptIn: string,
    user: any
) => {
    const url = process.env.REACT_APP_IDWAL_API_URL + "/Inspection/DataOptIn";
    const token = user.signInUserSession.idToken.jwtToken;

    axios
        .post(
            url,
            {
                InspectionId,
                CustomerOptIn
            },
            {
                headers: {
                    Authorization: "Bearer " + token
                }
            }
        )
        .then((result) => {
            return result.data;
        });
};

export const axiosGet = async (url: string) => {
    if (!url) {
        throw new Error("No inspection type url configured");
    }

    try {
        const result = await axios.get(url);

        if (!result.data) {
            throw new Error("No data");
        }

        return Promise.resolve(result.data);
    } catch (e: any) {
        throw new Error(e);
    }
};
